import React, { useContext } from 'react'
import { toast } from 'react-toastify'
import { BASE_URL_API } from '../../References/urls'
import AuthContext from '../../store/auth-context'
import styles from './CategorySelector.module.css'

const CategorySelector = (props) => {
    const authCtx = useContext(AuthContext)
    const { allCategories, selectedCategory, contentIdentifier } = props

    const categorySelectionHandler = async (k) => {
        console.log(k, contentIdentifier, selectedCategory)
        const response = await fetch(BASE_URL_API+"/updateRecruitContentCategory",
        {
            method : "POST",
            body : JSON.stringify({
                token : authCtx.token,
                id : contentIdentifier,
                category : k
            })
        });

        if(!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if(respo.status==="success") {
                toast(`Successfully updated the category!`)
            } else {
                if(respo?.message==="token Expired, please login again!") {
                    authCtx.logout()
                } 
            }
            console.log(respo)
        }
    }   



    return (
        <div className={styles.mainWrapper} >
            <select onChange={(e) => categorySelectionHandler(e.target.value)}  
                defaultValue={selectedCategory}
            >
                <option>Select Category</option>
                {allCategories?.map((item, index) => (
                    <option key={index} value={item?.id} >{item?.name}</option>
                ))}
            </select>
        </div>
    )
}

export default CategorySelector